import React from "react";
import { Box, Paper, Stack, Typography,ToggleButton ,ToggleButtonGroup} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const ToggleButtonColor = () => {
  const [alignment, setAlignment] = React.useState("web");

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Color
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              "const Index = () => {\n" +
              '  const [alignment, setAlignment] = React.useState("web");\n' +
              "\n" +
              "  const handleChange = (event, newAlignment) => {\n" +
              "    setAlignment(newAlignment);\n" +
              "  };\n" +
              "\n" +
              "  return (\n" +
              "    <ToggleButtonGroup\n" +
              '      color="primary"\n' +
              "      value={alignment}\n" +
              "      exclusive\n" +
              "      onChange={handleChange}\n" +
              "    >\n" +
              '      <ToggleButton value="web">Web</ToggleButton>\n' +
              '      <ToggleButton value="android">Android</ToggleButton>\n' +
              '      <ToggleButton value="ios">iOS</ToggleButton>\n' +
              "    </ToggleButtonGroup>\n" +
              "  );\n" +
              "};\n"
            }
          >
            <ToggleButtonGroup
              color="primary"
              value={alignment}
              exclusive
              onChange={handleChange}
              aria-label="Platform"
            >
              <ToggleButton value="web">Web</ToggleButton>
              <ToggleButton value="android">Android</ToggleButton>
              <ToggleButton value="ios">iOS</ToggleButton>
            </ToggleButtonGroup>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default ToggleButtonColor;
